@if (condition) {
  <section class="Impersonation">
    @if (context && config) {
      <div class="Impersonation__content">
        <p class="Impersonation__user">
          <span class="Impersonation__label">{{ config.label }}: </span>
          <span>{{ context[config.prop] }}</span>
        </p>
        <zip-button
          (zipButtonClicked)="onEndImpersonationClick()"
          [config]="config.button"
        >
        </zip-button>
      </div>
    }
  </section>
}
